export default [
  {
    path: '/admin/v2/spare-part-replacements',
    name: 'spare-part-replacement-v2',
    meta: { requiresAuth: true },
    component: () => import('@/pages/wholesale/replacement-v2/index.vue')
  },
  {
    path: '/admin/v2/spare-part-replacements/create',
    name: 'spare-part-replacement-create-v2',
    meta: { requiresAuth: true },
    component: () => import('@/pages/wholesale/replacement-v2/create.vue')
  },
  {
    path: '/admin/v2/spare-part-replacements/:id/edit',
    name: 'spare-part-replacement-edit-v2',
    meta: { requiresAuth: true },
    component: () => import('@/pages/wholesale/replacement-v2/edit.vue')
  }
]
